import React, { useState } from "react";
import AutoCompleteComponent from "../../components/AutoComplete";
import { useFormik } from "formik";
import { Button, Grid, IconButton, TextField, Box, Typography } from "@mui/material";
import Modal from "../../components/Modal";
import AddIcon from "@mui/icons-material/Add";

const ManagementForm = ({
    formik,
    handleRoomSelect,
    handleFurnitureSelect,
    rooms,
    furniture,
    furnitureFormik,
    handleModalRoomSelect,
    openFurnitureModal,
    setOpenFurnitureModal,
    handleRoomSubmit,
    roomName,
    setRoomName,
    openRoomModal,
    setOpenRoomModal
}) => {

    const handleRoomInputChange = (event) => {
        setRoomName(event.target.value);
    };

    const handleFurnitureClear = () => {
        formik.resetForm();
    }

    return (
        <Box sx={{ padding: { xs: 1, md: 2 } }}>
            <Box
                sx={{
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    backgroundColor: "#fbfdfe",
                    padding: { xs: 2, md: 3 },
                    marginBottom: 2,
                }}
            >
                <Typography variant="h5" sx={{ color: "#1976d2", marginBottom: 2, textAlign: "center" }}>
                    Manage Furniture Items
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={{ xs: 2, md: 3 }}>
                        <Grid item xs={12} md={3}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ flex: 1 }}>
                                    <AutoCompleteComponent
                                        options={rooms}
                                        onChange={() => { }}
                                        formikField={"room"}
                                        value={formik.values.room}
                                        label='Room'
                                        formik={formik}
                                        handleSelect={handleRoomSelect}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box sx={{ flex: 1 }}>
                                    <AutoCompleteComponent
                                        options={furniture}
                                        onChange={() => { }}
                                        formikField={"type"}
                                        value={formik.values.type}
                                        label='Furniture Type'
                                        formik={formik}
                                        handleSelect={handleFurnitureSelect}
                                    />
                                </Box>
                                <IconButton 
                                    onClick={() => setOpenFurnitureModal(true)}
                                    sx={{ color: "#1976d2" }}
                                    title="Add Furniture Type"
                                >
                                    <AddIcon />
                                </IconButton>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                id='name'
                                name='name'
                                label='Furniture Name'
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.name && Boolean(formik.errors.name)}
                                helperText={formik.touched.name && formik.errors.name}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                id='price'
                                name='price'
                                label='Price (₹)'
                                value={formik.values.price}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.price && Boolean(formik.errors.price)}
                                helperText={formik.touched.price && formik.errors.price}
                                type='number'
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: 3 }}>
                        <Grid item xs={12} sm={6} md={2}>
                            <Button
                                variant='outlined'
                                color='secondary'
                                fullWidth
                                onClick={handleFurnitureClear}
                                sx={{ height: 56 }}
                            >
                                Clear
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <Button
                                type='submit'
                                variant='contained'
                                color='primary'
                                fullWidth
                                sx={{ height: 56 }}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>
            <Modal open={openRoomModal} setOpen={setOpenRoomModal}>
                <Box sx={{ padding: 3 }}>
                    <Typography variant="h6" sx={{ marginBottom: 2, textAlign: "center", color: "#1976d2" }}>
                        Add New Room
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                id='room'
                                name='room'
                                label='Room Name'
                                value={roomName}
                                onChange={handleRoomInputChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button 
                                    variant='outlined' 
                                    onClick={() => setOpenRoomModal(false)}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant='contained' 
                                    onClick={handleRoomSubmit}
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
            <Modal open={openFurnitureModal} setOpen={setOpenFurnitureModal}>
                <Box sx={{ padding: 3 }}>
                    <Typography variant="h6" sx={{ marginBottom: 2, textAlign: "center", color: "#1976d2" }}>
                        Add New Furniture Type
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <AutoCompleteComponent
                                options={rooms}
                                onChange={() => { }}
                                formikField={"room"}
                                value={furnitureFormik.values.room}
                                label='Room'
                                formik={furnitureFormik}
                                handleSelect={handleModalRoomSelect}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                id='furnitureName'
                                name='furnitureName'
                                label='Furniture Type Name'
                                value={furnitureFormik.values.furnitureName}
                                onChange={furnitureFormik.handleChange}
                                onBlur={furnitureFormik.handleBlur}
                                error={furnitureFormik.touched.furnitureName && Boolean(furnitureFormik.errors.furnitureName)}
                                helperText={furnitureFormik.touched.furnitureName && furnitureFormik.errors.furnitureName}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button 
                                    variant='outlined' 
                                    onClick={() => setOpenFurnitureModal(false)}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant='contained' 
                                    onClick={furnitureFormik.handleSubmit}
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </Box>
    );
};

export default ManagementForm;
